// This is used when a user is not created in the backend
// but we still want to display a color for the avatar
// i.e.: attendees on calendar events that are not yet invited

export const getDefaultAvatarColor = letter => {
  const letterIndex = letter.charCodeAt(0) - 97;
  switch (letterIndex % 5) {
    case 0:
      return 'rgb(157, 98, 203)';
    case 1:
      return 'rgb(245, 194, 13)';
    case 2:
      return 'rgb(92, 110, 203)';
    case 3:
      return 'rgb(183, 210, 16)';
    case 4:
      return 'rgb(2, 187, 76)';
    default:
      return 'rgb(245, 194, 13)';
  }
};
